import { axios, Response } from '..'

export interface Body {
  fileUrl: string
}

export default async function syncDriveFileInBucket(
  body: Body
): Response<void> {
  const response = await axios.post(`v1/synchronize-drive`, body)

  return response
}
